import { CheckoutSteps } from 'features/events/checkout/types';
import TicketTiersContent from '../../TicketTiersContent';
import { useCheckout } from 'features/events/checkout/context';
import { useTranslation } from 'react-i18next';

const TicketTiersStepAddon = () => {
  const { t } = useTranslation(['checkout']);
  const { goToStep } = useCheckout();

  const onBack = () => {
    goToStep(CheckoutSteps.TicketTiers);
  };

  return (
    <TicketTiersContent
      onBack={onBack}
      showSpecialCodeForm={false}
      titleOverride={t('checkout:ticketsTiersAddonsTitle')}
    />
  );
};

export default TicketTiersStepAddon;
